module.exports = __webpack_public_path__ + "fonts-e0dca69c686a9f904fa5a8e467d244c4-GT-Eesti-Pro-Display-Regular-Italic-subset.woff2";